import { readableColor } from 'polished';
import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { safePolished } from '@/utils/safePolished';

export const StyledHeaderAccountButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
`;

export const StyledFirstName = styled.span`
  width: 100%;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const StyledNotificationsCounter = styled.span`
  display: flex;
  width: 50%;
  position: relative;
  margin-right: ${LAYOUT.GUTTER / 2}px;
`;

export const StyledNotificationDotMarker = styled.span`
  ${({ theme }) => {
    const { color } = getFontStyles(theme.header.font, ['color']);
    return `
    background: ${color ?? 'inherit'};
    color: ${safePolished(readableColor)(color)};
    `;
  }}
  borderRadius: 50%;
  fontsize: 9px;
  height: 16px;
  padding: 2px;
  position: absolute;
  right: -5px;
  top: -5px;
  width: 16px;
`;

export const StyledRewardsNotifications = styled.div`
  ${({ theme }) => {
    const { color } = getFontStyles(theme.header.font, ['color']);
    return `
      color: ${color};
      border: 1px solid ${color};
    `;
  }}
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledRewardNumber = styled.span`
  ${({ theme }) => {
    const { color } = getFontStyles(theme.header.font, ['color']);
    return `
      color: ${color};
    `;
  }}
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StyledAwardIcon = styled.div`
  ${({ theme }) => {
    const { color } = getFontStyles(theme.header.font, ['color']);
    return `
      background-color: ${color};
    `;
  }}
  width: 16px;
  height: 16px;
  mask-image: url('/static/img/icons/award.svg');
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url('/static/img/icons/award.svg');
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
`;
